import { proxyCustomElement, HTMLElement, h, Fragment, Host } from '@stencil/core/internal/client';
import { p as parseHrefProp } from './index10.js';
import { d as defineCustomElement$e } from './box.js';
import { d as defineCustomElement$d } from './button.js';
import { d as defineCustomElement$c } from './check-input.js';
import { d as defineCustomElement$b } from './form-field.js';
import { d as defineCustomElement$a } from './icon.js';
import { d as defineCustomElement$9 } from './list.js';
import { d as defineCustomElement$8 } from './list-item.js';
import { d as defineCustomElement$7 } from './loader.js';
import { d as defineCustomElement$6 } from './menu-pane.js';
import { d as defineCustomElement$5 } from './more-menu.js';
import { d as defineCustomElement$4 } from './status.js';
import { d as defineCustomElement$3 } from './tooltip.js';
import { d as defineCustomElement$2 } from './tooltip-label.js';

function isPropertySelector(parentLink) {
    if (parentLink && 'links' in parentLink) {
        return true;
    }
    return false;
}

const breadcrumbsCss = ":host{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;align-items:center;box-sizing:border-box;display:inline-flex;font-family:Open Sans;font-size:.875rem;font-weight:400;gap:.25rem;letter-spacing:-.0004em;line-height:1.25rem;line-height:normal}:host *,:host :after,:host :before{box-sizing:inherit}:host img{flex:none;overflow:hidden;text-overflow:ellipsis;white-space:pre-line}:host wui-icon{color:var(--jw-theme-surface-text-helper-color)}:host .parent-link-container{align-items:center;display:inline-flex;gap:.25rem}:host .current-page-container{color:var(--jw-theme-surface-text-description-color);font-family:Open Sans;font-size:.875rem;font-weight:600;letter-spacing:-.0004em;line-height:1.25rem;padding:0 .25rem}:host([truncate-breadcrumbs=true]) .parent-link-container>wui-button,:host([truncate-breadcrumbs=true]) .parent-link-container>wui-more-menu{max-width:8rem;text-overflow:ellipsis}";
const WuiBreadcrumbsStyle0 = breadcrumbsCss;

const WuiBreadcrumbs$1 = /*@__PURE__*/ proxyCustomElement(class WuiBreadcrumbs extends HTMLElement {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.parentLinks = [];
        this.truncateBreadcrumbs = false;
        this.currentPageTitle = '';
    }
    renderParentLinks() {
        const [firstLink, ...restOfParentLinks] = this.parentLinks || [];
        const lastLink = restOfParentLinks.pop();
        return (h(Fragment, null, firstLink &&
            (isPropertySelector(firstLink) ? (h("span", { class: "parent-link-container" }, h("wui-more-menu", { icon: "chevron-down", iconPosition: "trailing", menuPane: {
                    placement: 'bottom-start',
                }, label: firstLink.title, buttonType: "tertiary" }, h("wui-list", null, firstLink.links.map((link, idx) => (h("wui-list-item", { key: `${link.title}-${idx}`, label: link.title, as: ['a', parseHrefProp(link.href)] }))))), h("wui-icon", { name: "slash", size: "md" }))) : (h("span", { class: "parent-link-container" }, h("wui-button", { label: firstLink.title, as: ['a', parseHrefProp(firstLink.href)], type: "tertiary" }), h("wui-icon", { name: "slash", size: "md" })))), restOfParentLinks.length === 1 && (h("span", { class: "parent-link-container" }, h("wui-button", { label: restOfParentLinks[0].title, as: ['a', parseHrefProp(restOfParentLinks[0].href)], type: "tertiary" }), h("wui-icon", { name: "slash", size: "md" }))), restOfParentLinks.length > 1 && (h("span", { class: "parent-link-container" }, h("wui-more-menu", { icon: "dots", closeOnClickInside: true }, h("wui-list", null, restOfParentLinks.map((link, idx) => (h("wui-list-item", { key: `${link.title}-${idx}`, label: link.title, as: ['a', parseHrefProp(link.href)] }))))), h("wui-icon", { name: "slash", size: "md" }))), lastLink && (h("span", { class: "parent-link-container" }, h("wui-button", { label: lastLink.title, as: ['a', parseHrefProp(lastLink.href)], type: "tertiary" }), h("wui-icon", { name: "slash", size: "md" })))));
    }
    render() {
        return (h(Host, { key: 'b45ef2542a6868e5f2142ff7f2acad3da4c95294' }, this.renderParentLinks(), h("span", { key: 'c5f0929d4c289dddfe8ff85b043378f17ecb721b', class: "current-page-container" }, this.currentPageTitle)));
    }
    static get style() { return WuiBreadcrumbsStyle0; }
}, [1, "wui-breadcrumbs", {
        "parentLinks": [16],
        "truncateBreadcrumbs": [516, "truncate-breadcrumbs"],
        "currentPageTitle": [1, "current-page-title"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["wui-breadcrumbs", "wui-box", "wui-button", "wui-check-input", "wui-form-field", "wui-icon", "wui-list", "wui-list-item", "wui-loader", "wui-menu-pane", "wui-more-menu", "wui-status", "wui-tooltip", "wui-tooltip-label"];
    components.forEach(tagName => { switch (tagName) {
        case "wui-breadcrumbs":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, WuiBreadcrumbs$1);
            }
            break;
        case "wui-box":
            if (!customElements.get(tagName)) {
                defineCustomElement$e();
            }
            break;
        case "wui-button":
            if (!customElements.get(tagName)) {
                defineCustomElement$d();
            }
            break;
        case "wui-check-input":
            if (!customElements.get(tagName)) {
                defineCustomElement$c();
            }
            break;
        case "wui-form-field":
            if (!customElements.get(tagName)) {
                defineCustomElement$b();
            }
            break;
        case "wui-icon":
            if (!customElements.get(tagName)) {
                defineCustomElement$a();
            }
            break;
        case "wui-list":
            if (!customElements.get(tagName)) {
                defineCustomElement$9();
            }
            break;
        case "wui-list-item":
            if (!customElements.get(tagName)) {
                defineCustomElement$8();
            }
            break;
        case "wui-loader":
            if (!customElements.get(tagName)) {
                defineCustomElement$7();
            }
            break;
        case "wui-menu-pane":
            if (!customElements.get(tagName)) {
                defineCustomElement$6();
            }
            break;
        case "wui-more-menu":
            if (!customElements.get(tagName)) {
                defineCustomElement$5();
            }
            break;
        case "wui-status":
            if (!customElements.get(tagName)) {
                defineCustomElement$4();
            }
            break;
        case "wui-tooltip":
            if (!customElements.get(tagName)) {
                defineCustomElement$3();
            }
            break;
        case "wui-tooltip-label":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}
defineCustomElement$1();

const WuiBreadcrumbs = WuiBreadcrumbs$1;
const defineCustomElement = defineCustomElement$1;

export { WuiBreadcrumbs, defineCustomElement };

//# sourceMappingURL=wui-breadcrumbs.js.map